module.exports = __webpack_public_path__ + "img/default_profile.a2cbe2a.svg";